import React, { useEffect, useRef } from 'react'

export const ModalNotificacionNovedad = ({ novedades, setShowModal }) => {

    const myRef = useRef();

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [])

    const handleClickOutside = (event) => {
        if (
            myRef.current &&
            !myRef.current.contains(event.target)
        ) {
            localStorage.removeItem('notificaciones');
            setShowModal(false);
        }
    };

    return (
        <>
            <div className="background">
                &nbsp;&nbsp;
            </div>
            <div className="modalNotificacion sucursalConfimacion" ref={myRef}>
                <div className="modalAlerta">
                    <div
                        className="option"
                    >
                        <div
                            className="option-cerrar"
                            onClick={() => setShowModal(false)}
                        >
                            <h1>Cerrar</h1>
                            <i className="fas fa-times"> </i>
                        </div>
                    </div>
                    <div className="head">
                        <b>Novedades en el pedido:</b>
                    </div>
                    <div className="descripcion novedades">
                        {
                            novedades.map(
                                (nove, i) => {
                                    return (
                                        <p key={`${i}novedad`}>{nove}</p>
                                    )
                                }
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
